import React from 'react';

import {SortingDirections} from 'src/components/filter-header/constants';
import {DateRangeFilterHeader} from 'src/components/filter-header/date-range-filter-header';
import {DateRange} from 'src/components/filter-header/typedefs';
import {SortConfig} from 'src/hooks/useSortingRows';

type Props<F, C extends string, S> = {
    setFilter: (filterType: C, filterValue: DateRange) => void,
    filters: F,
    filteringColumnType: C,
    sortingColumnType?: S,
    onSort: (config: SortConfig<S>) => void,
    sortConfig: SortConfig<S>,
    caption: string,
    allowFutureDate?: boolean,
};

export const DateColumnHeader = <F extends Record<C, DateRange | string[]>, C extends string, S>(
    props: Props<F, C, S>,
) => {
    const {
        setFilter,
        filters,
        onSort,
        sortConfig,
        filteringColumnType,
        sortingColumnType,
        caption,
        allowFutureDate,
    } = props;

    const filterHandler = (filterValues: DateRange) => setFilter(filteringColumnType, filterValues);

    const sortHandler = (direction: SortingDirections) =>
        onSort({key: sortingColumnType, direction});

    return (
        <DateRangeFilterHeader
            caption={caption}
            isSorted={sortConfig.key === sortingColumnType}
            onSort={sortHandler}
            setFilter={filterHandler}
            filters={filters[filteringColumnType] as DateRange}
            allowFutureDate={allowFutureDate}
        />
    );
};
